import { BaseDto } from './BaseDto';
import { UiElementType } from 'classes/UIElementType';
import { List } from 'linqts';
import { NodeConnection } from './NodeConnection';
import { NodeTypes, MetaDataDto } from "dto/MetadataDto";

export class BaseNodeConfig extends BaseDto {
    TemplateId:string;
    NodeType:NodeTypes;    
    Reevaluate:boolean;
    TemplateValues:any;
    KeysOfTemplateValuesThatAreExpressions:string[] = [];
    TriggeredBy: NodeConnection[] = [];
    Remarks:string;
    
    private static readonly chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    
    constructor(template:MetaDataDto){
        super();
        
        // generate a random Identifier
        this.Identifier = '';
        for (var i = 10; i > 0; --i) this.Identifier += BaseNodeConfig.chars[Math.floor(Math.random() * BaseNodeConfig.chars.length)];

        this.TemplateValues = {
            ElementType : template.UiElementType
        };

        this.TemplateId = template.Identifier;
        this.NodeType = template.NodeType;
        
        // apply default values from template
        template.Properties.filter(x => x.DefaultValue).forEach(x => this.TemplateValues[x.PropertyName] = x.DefaultValue);
    }
}

export class RenderNodeConfig extends BaseDto{
    ResultValues:any[];
    Properties:any;
    Clickable:boolean;
}


// WEBPACK FOOTER //
// C:/git/flowdesigner/src/dto/NodeConfig.ts